import React, { Component } from 'react'
import { Meta, getLocalizedLabel, valueNotEmpty, valueIsIntNumber, getRefTargets, Feature, valueByFormikPath, valueInOptions } from '../../common'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import { UserMap, lastChangeLabel } from '../Edit'
import Input from './Input'
import Dropdown from './Dropdown'
import { Icon } from 'semantic-ui-react'
import TextArea from './TextArea'
import InputFeatureValueRef from './InputFeatureValueRef'
import { AxiosInstance } from 'axios'

interface InputFeatureValueProps extends WithTranslation {
    meta: Meta,
    http: AxiosInstance,
    cunitValues: any,
    feature: Feature,
    fmeta: any,
    fvaluepath: string,
    disabled: boolean,
    small?: boolean,
    label?: string,
    exLabel?: boolean,
    noHighlighting?: boolean,
    userMap: UserMap,
    validate?: (value: any) => string | undefined
}

class InputFeatureValue extends Component<InputFeatureValueProps> {

    render() {
        const { cunitValues, feature, meta, http, fmeta, fvaluepath, disabled, label, small, exLabel, noHighlighting, validate, userMap, t, i18n } = this.props
        const valueType = fmeta.params.value_type
        const options = valueType === 'enum' || valueType === 'flags' ? 
            fmeta.params.enum.map(o => {
                return { key: o.value, text: getLocalizedLabel(o.label, i18n.language), value: o.value}}
            ) : []
        let addInProps = { disabled: disabled }
        if (label && !exLabel) addInProps['label'] = label
        if (small) addInProps['size'] = 'mini'
        const iconSize = small ? 'small' : 'big'
        const lastChange = lastChangeLabel(feature, userMap) || fmeta.type
        const placeholder = t('undefined')

        if (valueType === 'ref' || valueType === 'multiref') {
            return(<InputFeatureValueRef feature={feature} name={fvaluepath} fmeta={fmeta} inputProps={{placeholder: placeholder, icon: null, ...addInProps}} meta={meta} cunitValues={cunitValues}
                        label={exLabel ? label : undefined} noHighlighting={noHighlighting} http={http}/>)
        } else {
            return (
                <span title={lastChange}>
                { !valueType && (!feature || feature.delete) ?
                    <Form.Field className="checkbox">
                    {exLabel ? <label htmlFor={`field_input_${fvaluepath}`}>{label}</label> : null}
                    {' '}
                    <Icon name="delete" color="red" size={iconSize}/>
                    </Form.Field>
                : !valueType && (feature && !feature.delete) ?
                    <Form.Field className="checkbox">
                    {exLabel ? <label htmlFor={`field_input_${fvaluepath}`}>{label}</label> : null}
                    {' '}
                    <Icon name="check" color="blue" size={iconSize}/>
                    </Form.Field>
                : valueType === 'str' || valueType === 'sstr' ?
                    <Input name={fvaluepath} inputProps={{placeholder: placeholder, ...addInProps}} validate={validate} label={exLabel ? label : undefined} noHighlighting={noHighlighting}/>
                : valueType === 'lstr' ?
                    <TextArea name={fvaluepath} rows={3} inputProps={{placeholder: placeholder, ...addInProps}} validate={validate} label={exLabel ? label : undefined} noHighlighting={noHighlighting}/>
                : valueType === 'text' ?
                    <TextArea name={fvaluepath} rows={8} inputProps={{placeholder: placeholder, ...addInProps}} validate={validate} label={exLabel ? label : undefined} noHighlighting={noHighlighting}/>
                : valueType === 'int' ?
                    <Input name={fvaluepath} inputProps={{type: "number", placeholder: placeholder, ...addInProps}} validate={validate || valueIsIntNumber} label={exLabel ? label : undefined} noHighlighting={noHighlighting}/>
                : valueType === 'float' ?
                    <Input name={fvaluepath} inputProps={{type: "number", placeholder: placeholder, ...addInProps}} validate={validate} label={exLabel ? label : undefined} noHighlighting={noHighlighting}/>
                : valueType === 'enum' ?
                    <Dropdown name={fvaluepath} options={options} inputProps={{placeholder: placeholder, icon: null, ...addInProps}} validate={validate} label={label} noHighlighting={noHighlighting}/>
                : valueType === 'flags' ?
                    <Dropdown name={fvaluepath} options={options} inputProps={{multiple: true, selection: true, placeholder: placeholder, icon: null, ...addInProps}} label={label}
                        validate={validate} noHighlighting={noHighlighting}/>
                : null}
                </span>
            )
        }

    }
}

export default withTranslation()(InputFeatureValue)